import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Title } from '@angular/platform-browser';
import styler from 'stylerjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeManagerService {
  private themeClass = '';
  themeColors = {
    primary: undefined,
    accent: undefined,
    warn: undefined
  }

  constructor(private overlayContainer: OverlayContainer, private titleService: Title) { }

  setThemeClass(themeClass:string) {
    this.themeClass = themeClass;
    const oc = this.overlayContainer.getContainerElement();
    oc.classList.remove('riskrats-theme')
    oc.classList.remove('sienna-theme')
    oc.classList.remove('connectwise-theme');
    oc.classList.remove('continuum-theme');
    oc.classList.remove('alliancebernstein-theme');
    oc.classList.remove('sentrian-theme');
    oc.classList.remove('sbam-theme');
    if (this.themeClass) {
      oc.classList.add(this.themeClass);
    }
    switch (this.themeClass) {
      case ('sbam-theme'):
        this.titleService.setTitle('Risk Assessments');
      break;
      case ('connectwise-theme'):
      default:
        this.titleService.setTitle('ConnectWise Identify');
    }
  }

  getThemeClass():string {
    return this.themeClass;
  }

  updateThemeColors() {
    const primary = styler('.text-primary').get(['color']);
    const accent = styler('.text-accent').get(['color']);
    const warn = styler('.text-warn').get(['color']);

    this.themeColors = {primary: this.rgbCssToHex(primary.color), accent: this.rgbCssToHex(accent.color), warn: this.rgbCssToHex(warn.color)};
  }

  private rgbCssToHex(str) {
    const s = str.replace('rgb(', '').replace(')', '');
    const rgb = s.split(',');
    const red = this.rgbToHex(rgb[0].trim());
    const green = this.rgbToHex(rgb[1].trim());
    const blue = this.rgbToHex(rgb[2].trim());
    return `#${red}${green}${blue}`;
  }

  private rgbToHex (rgb) {
    let hex = Number(rgb).toString(16);
    if (hex.length < 2) {
         hex = '0' + hex;
    }
    return hex;
  };

  getLayoutLogo():string {
    let logo:string;
    switch (this.themeClass) {
      case ('riskrats-theme'):
        logo = '/assets/themes/riskrats/logo-darker-green.svg';
        break;
      case ('sienna-theme'):
        logo = '/assets/themes/sienna/logo-3color.svg';
        break;
      case ('alliancebernstein-theme'):
        logo = '/assets/themes/alliancebernstein/AllianceBernstein_2017_horiz.svg';
        break;
      case ('sentrian-theme'):
        logo = '/assets/themes/sentrian/Sentrian_Logo_RGB.png';
        break;
      case ('sbam-theme'):
        logo = '/assets/themes/sbam/SBAM_logo.svg';
        break;
      case ('connectwise-theme'):
      default:
        logo = '/assets/themes/connectwise-identify/full-color-identify-logo-lowercase.svg';
    }

    return logo;
  }

  getStackedLogo(): string {
    let logo:string;
    switch (this.themeClass) {
      case ('riskrats-theme'):
        logo = '/assets/themes/riskrats/logo-subtitle-stacked-darker-green.svg';
        break;
      case ('sienna-theme'):
        logo = '/assets/themes/sienna/logo-stacked-3color.svg';
        break;
      case ('alliancebernstein-theme'):
        logo = '/assets/themes/alliancebernstein/AllianceBernstein_2017_horiz.svg';
        break;
      case ('sentrian-theme'):
        logo = '/assets/themes/sentrian/Sentrian_Logo_RGB.png';
        break;
      case ('sbam-theme'):
        logo = '/assets/themes/sbam/SBAM_logo.svg';
        break;
      case ('connectwise-theme'):
      default:
        logo = '/assets/themes/connectwise-identify/full-color-identify-logo-lowercase.svg';
    }

    return logo;
  }

  getWhiteLogo(): string {
    let logo:string;

    switch (this.themeClass) {
      case ('connectwise-theme'):
        logo = '/assets/themes/connectwise-identify/white-identify-logo-lowercase.svg';
        break;
      default:
        logo = this.getStackedLogo();
    }

    return logo;
  }

  getUnderlayStyle(light = false): {} {
    let ret:{};
    switch (this.themeClass) {
      case ('riskrats-theme'):
        if (light) {
          ret = {'background-image': 'url(/assets/themes/riskrats/maze-illustrated-3d-thin-grey.png)','background-size': 'cover'};
        } else {
          ret = {'background-image': 'url(/assets/themes/riskrats/maze-illustrated-3d-thin-blue.png)','background-size': 'cover'};
        }
        break;
      case ('sienna-theme'):
        if (light) {
          ret = {'background-image': 'url(/assets/themes/sienna/pattern-illustrated-grey.png)','background-size': 'cover'};
        } else {
          ret = {'background-image': 'url(/assets/themes/sienna/pattern-illustrated-blue.png)','background-size': 'cover'};
        }
        break;
      case ('alliancebernstein-theme'):
      case ('sentrian-theme'):
      case ('sbam-theme'):
      case ('connectwise-theme'):
      default:
        if (light) {
          ret = {'background-image': 'url(/assets/themes/connectwise-identify/maze-illustrated-3d-thin-grey.png)','background-size': 'cover'};
        } else {
          ret = {'background-image': 'url(/assets/themes/connectwise-identify/maze-illustrated-3d-thin-cw-blue.png)','background-size': 'cover'};
        }
  }

    return ret;
  }
}

export class ReportTheme {
  baseColor: string;
  highlightColor: string;
  textBackgroundColor: string;
  lowScoreColor: string;
  mediumScoreColor: string;
  highScoreColor: string;
  criticalScoreColor: string;
  documentTitlePage: string;
  documentPageHeader: string;
  nistSubSectionTable: string;
}
